import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { getEmployeeByUserId } from "../../../core/data/redux/employee/employeeAction";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import {
  exportToCSV,
  exportToExcel,
  exportToPDF,
} from "../../../core/common/GlobalFunctions/exportTableData";
import { message } from "antd";
import AssetMaintenanceFilterHeader from "./AssetMaintenanceFilterHeader";
import {
  getMaintenanceTypeCards,
  getStatusMaintenanceCards,
  getTotalAssetsCard,
} from "./MaintenanceTypeCard";
import AssetMaintenanceModal from "./assetMaintenancemodal";
import {
  deleteMaintenance,
  fetchAllMaintenances,
  fetchMaintenancesByEmployeeId,
} from "../../../core/data/redux/asset/assetMaintenanceAction/assetMaintenanceAction";
import { } from "../../mainMenu/requestDashboard/StatusSummaryCards";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { formatDate } from "../../../core/utils/configFormatters";
import { decryptData } from "../../../core/utils/encryptUtils";
const AssetMaintenance = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { user } = useSelector((state: any) => state.auth);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const { maintenanceByEmployee = [] } = useSelector((state: any) => state.asset.assetMaintenance);
  const employeeId = employeesbyUser?.employeeId;
  const maintenanceId = selectedRowData?.maintenance_id;

  useEffect(() => {
    if (!employeesbyUser?.employeeId && user?.UserId) {
      dispatch(getEmployeeByUserId({ userId: user.UserId }));
    }
    if (employeesbyUser?.employeeId) {
      dispatch(fetchMaintenancesByEmployeeId(employeesbyUser?.employeeId));
    }
  }, [dispatch, employeesbyUser, user]);

  const handleOpenModal = (type: "edit" | "create", data?: any) => {
    setModalType(type);
    setSelectedRowData(data || null);
    setIsModalVisible(true);
  };

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  const handleDeleteRequest = async (id: number) => {
    try {
      const result = await dispatch(deleteMaintenance(id));
      if (result.meta.requestStatus === "fulfilled") {
        message.success("Deleted successfully");
        setIsDeleteModalVisible(false);
        dispatch(fetchAllMaintenances());
        setTableKey((prev) => prev + 1);
      } else {
        const errorPayload = result.payload as { error: string };
        message.error(errorPayload?.error || "Delete failed");
      }
    } catch {
      message.error("Something went wrong");
    }
  };

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { status: selectedStatus }
        : {};
    return filterData(maintenanceByEmployee || [], filters, "created_at", "created_at", selectedSort);
  }, [maintenanceByEmployee, selectedStatus, selectedSort]);

  // const exportData = filteredData.map((item: any) => ({
  //   ...item,
  //   maintenance_date: item.maintenance_date ? new Date(item.maintenance_date).toISOString().split("T")[0] : "N/A",
  //   next_due_date: item.next_due_date ? new Date(item.next_due_date).toISOString().split("T")[0] : "N/A",
  //   created_at: item.created_at ? new Date(item.created_at).toISOString().split("T")[0] : "N/A",
  //   modified_at: item.modified_at ? new Date(item.modified_at).toISOString().split("T")[0] : "N/A",
  // }));

  function filterMaintenanceData(data: any[]) {
  return data.map(item => ({
    maintenanceType: item.maintenance_type || "N/A",
    maintenanceDate: item.maintenance_date ? new Date(item.maintenance_date).toLocaleDateString() : "N/A",
    maintenanceNumber: item.maintenance_number || "N/A",
    nextDueDate: item.next_due_date ? new Date(item.next_due_date).toLocaleDateString() : "N/A",
    vendorName: item.vendor_name || "N/A",
    description: item.description || "N/A",
    status: item.status || "N/A",
    requestStatus: item.request_status || "N/A",
    createdAt: item.created_at ? new Date(item.created_at).toLocaleDateString() : "N/A",
    modifiedAt: item.modified_at ? new Date(item.modified_at).toLocaleDateString() : "N/A",
    assetName: item.AssetName || "N/A",
    serialNumber: item.SerialNumber || "N/A",
  }));
}

const exportData = filterMaintenanceData(maintenanceByEmployee)



  useEffect(() => {
    setTableKey((prev) => prev + 1);
  }, [selectedStatus, selectedSort, maintenanceByEmployee]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Maintenance ID",
      dataIndex: "maintenance_number",
      render: (text: string) => <span style={{ color: 'red' }}>{text}</span>,
    },
    {
      title: "Maintenance Type",
      dataIndex: "maintenance_type",
      render: (type: string) => type?.charAt(0).toUpperCase() + type?.slice(1),
    },
    {
      title: "AssetName",
      dataIndex: "AssetName",
    },
    {
      title: "Serial Number",
      dataIndex: "SerialNumber",
    },

    {
      title: "Maintenance Date",
      dataIndex: "maintenance_date",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) =>
        new Date(a.maintenance_date).getTime() -
        new Date(b.maintenance_date).getTime(),
    },
    {
      title: "Next Due Date",
      dataIndex: "next_due_date",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) =>
        new Date(a.next_due_date).getTime() -
        new Date(b.next_due_date).getTime(),
    },
    {
      title: "Cost",
      dataIndex: "cost",
      sorter: (a: any, b: any) => a.cost - b.cost,
    },
    {
      title: "Vendor",
      dataIndex: "vendor_name",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status: string) => {
        const statusClass =
          {
            scheduled: "badge-info",
            in_progress: "badge-warning",
            completed: "badge-success",
            cancelled: "badge-danger",
            paid: "badge-success",
            unpaid: "badge-danger",
          }[status] || "";

        return (
          <span
            className={`badge ${statusClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {status}
          </span>
        );
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text: string) => (
        <span
          className="text-truncate d-inline-block"
          style={{ minWidth: 200 }}
        >
          {text}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (_: string, record: any) => {
        const isStatusRestricted = record.request_status === "Approved" || record.request_status === "Rejected";
        const isEditDisabled = !canEdit || isStatusRestricted;
        const isDeleteDisabled = !canDelete || isStatusRestricted;

        return (
          <div className="action-icon d-inline-flex">
            {/* Edit Button */}
            <button
              className="me-2"
              onClick={() => {
                if (!isEditDisabled) handleOpenModal("edit", record);
              }}
              disabled={isEditDisabled}
              style={{
                cursor: isEditDisabled ? "not-allowed" : "pointer",
                opacity: isEditDisabled ? 0.5 : 1,
              }}
              title={isEditDisabled ? "No permission to edit" : "Edit"}
            >
              <i className="ti ti-edit" />
            </button>

            {/* Delete Button */}
            <button
              className="me-2"
              onClick={() => {
                if (!isDeleteDisabled) {
                  setSelectedRowData(record);
                  setIsDeleteModalVisible(true);
                }
              }}
              disabled={isDeleteDisabled}
              style={{
                cursor: isDeleteDisabled ? "not-allowed" : "pointer",
                opacity: isDeleteDisabled ? 0.5 : 1,
              }}
              title={isDeleteDisabled ? "No permission to delete" : "Delete"}
            >
              <i className="ti ti-trash" />
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div>
              <h2 className="mb-1">Asset Maintenance</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Asset</li>
                  <li className="breadcrumb-item active">Request</li>
                </ol>
              </nav>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              {canExport && (
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" /> Export
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() =>
                          exportToCSV(exportData, "asset_maintenance_data")
                        }
                        className="dropdown-item"
                      >
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() =>
                          exportToExcel(exportData, "asset_maintenance_data")
                        }
                        className="dropdown-item"
                      >
                        Export as Excel
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() =>
                          exportToPDF(exportData, "asset_maintenance_data")
                        }
                        className="dropdown-item"
                      >
                        Export as PDF
                      </button>
                    </li>
                  </ul>
                </div>
              )}
              {canAdd && (
                <button
                  className="btn btn-primary d-flex align-items-center"
                  onClick={() => handleOpenModal("create")}
                >
                  <i className="ti ti-circle-plus me-2" /> Add Maintenance
                </button>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="row">
            {getTotalAssetsCard(maintenanceByEmployee)}{" "}
            {getStatusMaintenanceCards(maintenanceByEmployee)}{" "}
            {getMaintenanceTypeCards(maintenanceByEmployee)}
          </div>
          {/* Filters */}
          <div className="card">
            <AssetMaintenanceFilterHeader
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
              selectedSort={selectedSort}
              setSelectedSort={setSelectedSort}
            />
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer d-sm-flex justify-content-between bg-white p-3 border-top">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>

      {/* Modals */}
      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => maintenanceId && handleDeleteRequest(maintenanceId)}
      />
      <AssetMaintenanceModal
        modalType={modalType}
        isModalVisible={isModalVisible}
        handleCancel={() => setIsModalVisible(false)}
        employeeId={employeeId}
        setTableKey={setTableKey}
        maintenanceId={maintenanceId}
        selectedRowData={selectedRowData}
      />
    </>
  );
};

export default AssetMaintenance;
